import searchfilter from './data/filter.json';
import parse from 'html-react-parser';
import Chip from '@mui/material/Chip';

export const returnFilterText = (key, value) => {
    let item = searchfilter.filter(x => x.key === key);
    item = item[0];
    let display = item.option.filter(x => x.key === value);
    // console.log(item, display);
    return display[0] && display[0].value ? display[0].value : value;
};

export const stringToReactElement = (htmlString) => {
    if (typeof (htmlString) != "string")
        htmlString = htmlString.toString();
    return parse(htmlString);
}


export const isEmptyObject = (obj) => {
    if (obj // 👈 null and undefined check
        && Object.keys(obj).length === 0
        && Object.getPrototypeOf(obj) === Object.prototype)
        return true;
    return false;
};

export const TwoArrayHasCommonElement = (array1, array2) => {
    const filteredArray = array1.filter(value => array2.includes(value));
    return filteredArray.length > 0;
};


export const statusLabel = (status, type) => {
    let elm = null;

    if (type === "card") {
        switch (status) {
            case "earlybird_open":
            case "onsale_open":
            case "limited":
                let label = returnFilterText("status", status);
                elm = (<div className={'statustag ' + status}>{label}</div>);
                break;
            default:
                // nothing
                break;
        }
    }
    else {
        switch (status) {
            case "onsale_open":
                elm = <Chip size="small" color="success" label="開售中" className='statuslabel' />
                break;
            case "earlybird_open":
                elm = <Chip size="small" color="success" label="早鳥中" className='statuslabel' />
                break;
            case "earlybird_close":
                elm = <Chip size="small" label="早鳥完結" className='statuslabel' />
                break;
            case "onsale_closed":
                elm = <Chip size="small" label="停止售賣" className='statuslabel' />
                break;
            case "limited":
                elm = <Chip size="small" label="售完即止" className='statuslabel' color="primary" />
                break;
            default:
                elm = "";
                break;
        }
    }
    return elm;
};